module.exports = __webpack_public_path__ + "img/request.9029f341.png";